module.exports = __webpack_public_path__ + "img/icon-action-more.3678dd87.svg";